import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ReasonsDropDown } from './reason-drop-down.dto';



export class ReasonsDropDownResponse extends GlobalResponseObject {
    data?: ReasonsDropDown[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ReasonsDropDown[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

